import axios from "../plugins/axios";
import { PORTAL_CONFIG } from "../config";

export default {
  // eslint-disable-next-line no-unused-vars
  sendComment(ticketID, comment) {
    return axios.post(
      `/Ticket/${ticketID}/ITILFollowup/?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          content: comment,
          itemtype: "Ticket",
          items_id: "" + ticketID
        }
      }
    );
  },
  affectPerson(ticketID, userID) {
    return axios.post(
      `/Ticket/${ticketID}/Ticket_User/?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          tickets_id: ticketID,
          users_id: userID,
          type: 2,
          use_notification: 1
        }
      }
    );
  },
  cloreIncident(ticketID, comment) {
    return axios.post(
      `/Ticket/${ticketID}/ITILSolution/?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          content: comment,
          itemtype: "Ticket",
          items_id: ticketID
        }
      }
    );
  },
  addTask(ticketID, { start, end, content }, groupID, userID) {
    return axios.post(
      `/Ticket/${ticketID}/TicketTask?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          content: content,
          tickets_id: ticketID,
          begin: start,
          end: end,
          groups_id_tech: groupID,
          users_id_tech: userID
        }
      }
    );
  },

  addImageDoc(uploadImage, originalImg) {
    axios.defaults.headers["Content-Type"] = "multipart/form-data";
    let formData = new FormData();
    formData.append(
      "uploadManifest",
      JSON.stringify({
        input: {
          name: "Ticket - Photo",
          _filename: [originalImg.name],
          documentcategories_id: "5",
          comment: "XXX"
        }
      })
    );
    formData.append("filename[0]", uploadImage);
    return axios.post(
      `/Document?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      formData
    );
  },
  attachDocumentToItem(ticketID, documentID) {
    axios.defaults.headers["Content-Type"] = "application/json";

    return axios.post(
      `Ticket/${ticketID}/Document_Item?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          documents_id: documentID,
          itemtype: "Ticket",
          items_id: ticketID
        }
      }
    );
  },

  getDocuments(entityID) {
    return axios.get(
      `/Ticket/${entityID}/Document_Item/?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getDocumentsItems() {
    return axios.get(
      `/Document_Item/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getITILFollowupByID(ITILFollowupID) {
    return axios.get(
      `/ITILFollowup/${ITILFollowupID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getITILSolutionByID(ITILSolutionID) {
    return axios.get(
      `/ITILSolution/${ITILSolutionID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getTaskByID(taskID) {
    return axios.get(
      `/TicketTask/${taskID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getTransportData() {
    return axios.get(
      `/PluginFieldsEntitypiloteimmoentite?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  async getReservations(date = null) {
    let url = `/reservation?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`;
    if (date) {
      url += `&searchText[begin]=${date}`;
    }
    return axios.get(url);
  },
  getReservationItems() {
    return axios.get(
      `/ReservationItem?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getReservationItem(itemtype, items_id) {
    return axios.get(
      `${itemtype}/${items_id}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getCity(entityID) {
    return axios.get(
      `/PluginFieldsEntitypiloteimmoentite?app_token=${PORTAL_CONFIG.APP_TOKEN}&searchText[items_id]=${entityID}`
    );
  },

  getListSearchOptions(entity) {
    return axios.get(
      `/listSearchOptions/${entity}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },

  getDocument(document_id, blob = false) {
    if (blob) {
      return axios(
        `/Document/${document_id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&alt=media`,
        {
          responseType: "blob" // important,
        }
      );
    } else {
      return axios.get(
        `/Document/${document_id}?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
      );
    }
  },
  getMyEntity(entityID) {
    return axios.get(`entity/${entityID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  getGroup(entitiesID) {
    return axios.get(
      `group?searchText[entities_id]=${entitiesID}&app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getTasks() {
    return axios.get(
      `/TicketTask/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getItemType(itemType) {
    return axios.get(
      `/${itemType}?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getTicketUser(ticketID) {
    return axios.get(
      `Ticket/${ticketID}/Ticket_User/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  deleteTicketUser(ticketID, userID) {
    return axios.delete(
      `Ticket/${ticketID}/Ticket_User/${userID}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  changeName(ticketID, item_type, itemtype_ID, Name) {
    return axios.put(
      `/Ticket/${ticketID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: {
          name: JSON.stringify({
            itemtype: item_type,
            itemtypeID: itemtype_ID,
            titre: Name
          })
        }
      }
    );
  },
  changeDescription(ticketID, Content) {
    return axios.put(
      `/Ticket/${ticketID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`,
      {
        input: { content: Content }
      }
    );
  }
};
